
import { useParams } from "react-router-dom";

import { Box } from "@mui/material";
import { DisenioGranja } from "../../layout";
import { useBodegaXGranja } from "../../../hooks";
import { CargandoMedio, TablaListBodegas } from "../../components";




export const BodegasXGranja = () => {


    const { id } = useParams();
    const { bodegaXGranjaQuery } = useBodegaXGranja(id);



    return (

        <DisenioGranja titulo="Bodegas de Granja" add={false}>
            {(bodegaXGranjaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Bodegas..." />
            :   <TablaListBodegas data={bodegaXGranjaQuery.data || []} />
            }

            <Box sx={{height:30}} />
        </DisenioGranja>

    )
}
